import { render, staticRenderFns } from "./errmsg.vue?vue&type=template&id=1fd4ffa3&scoped=true"
import script from "./errmsg.vue?vue&type=script&lang=js"
export * from "./errmsg.vue?vue&type=script&lang=js"
import style0 from "./errmsg.vue?vue&type=style&index=0&id=1fd4ffa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4ffa3",
  null
  
)

export default component.exports